import coreMap from 'gatsby-theme-pagebuilder/src/components/blocks/static/static-mapping';
import SplitBlock from './split-block';
import Logos from './logos';

export default {
  ...coreMap,
  split_block: SplitBlock,
  logos: Logos,
};
